import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const getToken = () => localStorage.getItem('token');

// Companies
export const getCompanies = async () => {
  const response = await axios.get(`${API}/companies?token=${getToken()}`);
  return response.data;
};

export const getCompany = async (companyId) => {
  const response = await axios.get(`${API}/companies/${companyId}?token=${getToken()}`);
  return response.data;
};

export const createCompany = async (data) => {
  const response = await axios.post(`${API}/companies?token=${getToken()}`, data);
  return response.data;
};

export const deleteCompany = async (companyId) => {
  const response = await axios.delete(`${API}/companies/${companyId}?token=${getToken()}`);
  return response.data;
};

// Admin
export const adminGetAllCompanies = async () => {
  const response = await axios.get(`${API}/admin/companies?token=${getToken()}`);
  return response.data;
};

export const adminGetCompanyFull = async (companyId) => {
  const response = await axios.get(`${API}/admin/companies/${companyId}/full?token=${getToken()}`);
  return response.data;
};

// Email
export const sendReport = async (companyId) => {
  const response = await axios.post(`${API}/companies/${companyId}/send-report?token=${getToken()}`);
  return response.data;
};

// Areas & Obligations
export const getAreas = async () => {
  const response = await axios.get(`${API}/areas`);
  return response.data;
};

export const getObligations = async () => {
  const response = await axios.get(`${API}/obligations`);
  return response.data;
};

export const getObligationsByArea = async (areaId) => {
  const response = await axios.get(`${API}/areas/${areaId}/obligations`);
  return response.data;
};

export const createObligation = async (data) => {
  const response = await axios.post(`${API}/obligations?token=${getToken()}`, data);
  return response.data;
};

export const deleteObligation = async (obligationId) => {
  const response = await axios.delete(`${API}/obligations/${obligationId}?token=${getToken()}`);
  return response.data;
};

// Compliance Responses
export const getResponses = async (companyId) => {
  const response = await axios.get(`${API}/companies/${companyId}/responses?token=${getToken()}`);
  return response.data;
};

export const saveResponses = async (companyId, responses) => {
  const response = await axios.post(`${API}/companies/${companyId}/responses?token=${getToken()}`, {
    company_id: companyId,
    responses: responses
  });
  return response.data;
};

// Stats
export const getStats = async (companyId) => {
  const response = await axios.get(`${API}/companies/${companyId}/stats?token=${getToken()}`);
  return response.data;
};

// Audit Logs
export const getAuditLogs = async (companyId, limit = 50) => {
  const response = await axios.get(`${API}/companies/${companyId}/audit?token=${getToken()}&limit=${limit}`);
  return response.data;
};

// Documents
export const getDocuments = async (companyId, obligationId = null) => {
  let url = `${API}/companies/${companyId}/documents?token=${getToken()}`;
  if (obligationId) url += `&obligation_id=${obligationId}`;
  const response = await axios.get(url);
  return response.data;
};

export const uploadDocument = async (companyId, file, obligationId = null) => {
  const formData = new FormData();
  formData.append('file', file);
  let url = `${API}/companies/${companyId}/documents?token=${getToken()}`;
  if (obligationId) url += `&obligation_id=${obligationId}`;
  const response = await axios.post(url, formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
  return response.data;
};

export const downloadDocument = async (documentId) => {
  const response = await axios.get(`${API}/documents/${documentId}/download?token=${getToken()}`, {
    responseType: 'blob'
  });
  return response.data;
};

export const deleteDocument = async (documentId) => {
  const response = await axios.delete(`${API}/documents/${documentId}?token=${getToken()}`);
  return response.data;
};

// Seed
export const seedData = async () => {
  const response = await axios.post(`${API}/seed`);
  return response.data;
};
